import { render, staticRenderFns } from "./OverviewSettings.vue?vue&type=template&id=1bbef507&"
import script from "./OverviewSettings.vue?vue&type=script&lang=ts&"
export * from "./OverviewSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports